import React, { useState } from 'react';
import { Link } from 'react-router-dom';

type LoginTypes = {
  email: string;
}

const LoginCard = () => {

  const [loginData, setLoginData] = useState<LoginTypes>({
    email: ''
  });

  const handleEmailChange = (event: any) => {
    setLoginData((prevState) => ({
      ...prevState,
      email: event.target.value
    }));
  };

  const handleFormSubmit = (event: any) => {
    event.preventDefault();
  }

  return (
    <div className="row w-75 d-flex justify-content-center align-items-center">
      <div className="col-md-12">
        <div className="card card-shadow mt-5">
          <div className="card-header" style={{ backgroundColor: '#DC143C', textAlign: 'center', color: '#FFF', fontWeight: 'bold' }} >
            Login
        </div>
          <div className="card-body">
            <form onSubmit={handleFormSubmit}>
              <div className="form-group row">
                <label htmlFor="email" className="col-md-4 col-form-label text-md-right">Email</label>
                <div className="col-md-6">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={loginData.email}
                    required
                    autoComplete="email"
                    autoFocus
                    onChange={handleEmailChange}
                  />
                </div>
              </div>
              <div className="form-group row mb-0">
                <div className="col-md-8 offset-md-4">
                  <button type="submit" className="btn btn-primary" style={{ backgroundColor: '#DC143C', borderColor: '#DC143C', fontWeight: 'bold' }}>
                    Send Password Reset Link
                  </button>
                </div>
              </div>
              <div className="form-group row mb-0">
                <div className="col-md-8 offset-md-4 mt-4">
                  <Link to='/'>Go Back to Login</Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
};

export default LoginCard;